function NewsBar(props) {
	if(props.display !== "none") {
		return(
			<div className="homepage-navbar shadow px-3 py-2 mb-2" style={{backgroundImage: "linear-gradient(43deg, #f8f9fa -100%, #F0B600 100%)"}}>
				<div className="d-flex align-items-center justify-content-center">
					<h6 className="m-0 text-center">🎆 Fête du lac : service ouvert mais livraison impossible à certaines adresses. <a className="text-dark text-decoration-underline" href="/content/28-fete-du-lac">Détails</a></h6>
				</div>
			</div>
		);
	}
}
export default NewsBar;